module.exports = __webpack_public_path__ + "img/transfusion_icon_white.5c6e1157.svg";